import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { UIState } from "@/types";

interface UIActions {
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  setTheme: (theme: "light" | "dark") => void;
  setLoading: (loading: boolean) => void;
}

type UIStore = UIState & UIActions;

export const useUIStore = create<UIStore>()(
  persist(
    (set) => ({
      sidebarOpen: true,
      theme: "dark",
      isLoading: false,

      toggleSidebar: () => {
        set((state) => ({ sidebarOpen: !state.sidebarOpen }));
      },

      setSidebarOpen: (sidebarOpen: boolean) => {
        set({ sidebarOpen });
      },

      setTheme: (theme: "light" | "dark") => {
        set({ theme });

        if (typeof window !== "undefined") {
          const root = window.document.documentElement;

          // Remove existing dark class first
          root.classList.remove("dark");

          if (theme === "dark") {
            root.classList.add("dark");
          }
        }
      },

      setLoading: (isLoading: boolean) => {
        set({ isLoading });
      },
    }),
    {
      name: "ui-storage",
      partialize: (state) => ({
        theme: state.theme,
        sidebarOpen: state.sidebarOpen,
      }),
    }
  )
);